const isValidJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e: unknown) {
    return false;
  }
};

export { isValidJSON };
